export default "__VITE_ASSET__BbKpBZKA__"